import { ICourseTitleBar, ICourseProgress, ICourseReview } from './utils/type';
import { ICourseDetail } from '@/pages/courseDetail/utils/type';
import { getStarTotalData } from './utils/func';

export const initTitleBarProps: ICourseTitleBar = {
  id: 0,
  title: '',
  viewCount: 0,
  tenantId: 0,
  showDiscountPrice: false, // 是否显示折扣价
  fixedPrice: 0, // 折扣价
  price: 0, // 原价
  remainingDiscountTime: null, // 优惠剩余时间
  hadBuyed: false, // 是否购买
  restrictionSwitch: null,
  hadRegistration: null,
  shortUrl: '',
  type: 0,
  hadFavorite: false,
  liveCourseLessonId: null,
  teacherBackground: '',
  teacherName: '',
  teacherAvatarUrl: '',
  assistantQrCode: null,
  contentType: null,
  courseContentLink: '',
};

export const initProgressProps: ICourseProgress = {
  maxProgress: 0,
  nowProgress: 0,
  courseId: 0,
  chapterId: 0,
};

export const initCourseReview: ICourseReview = {
  star: 0,
  hadReview: false,
};
export const getTitleBarDataList = (detailData: ICourseDetail): ICourseTitleBar => {
  const {
    title,
    id,
    viewCount,
    tenantId,
    showDiscountPrice,
    fixedPrice,
    price,
    remainingDiscountTime,
    hadBuyed,
    restrictionSwitch,
    hadRegistration,
    shortUrl,
    type,
    hadFavorite,
    liveCourseLessonId,
    teacherName,
    teacherAvatarUrl,
    teacherBackground,
    assistantQrCode,
    contentType,
    courseContentLink,
  } = detailData;
  return {
    id,
    title,
    viewCount,
    tenantId,
    showDiscountPrice,
    fixedPrice,
    price,
    remainingDiscountTime,
    hadBuyed,
    hadFavorite,
    restrictionSwitch,
    hadRegistration,
    shortUrl,
    type,
    liveCourseLessonId,
    teacherName,
    teacherAvatarUrl,
    teacherBackground,
    assistantQrCode,
    contentType,
    courseContentLink,
  };
};

export const calcStarTotalData = (res) => {
  if (!res) {
    return;
  }

  let totalStar = 0;
  let totalCount = 0;
  let star = 0;
  const { starMap, hadReview, recommendStarMap, teacherStarMap } = res;
  if (starMap) {
    const data = getStarTotalData(starMap, totalCount, totalStar);
    totalStar = data.totalStar;
    totalCount = data.totalCount;
  }
  if (teacherStarMap) {
    const data = getStarTotalData(teacherStarMap, totalCount, totalStar);
    totalStar = data.totalStar;
    totalCount = data.totalCount;
  }
  if (recommendStarMap) {
    const data = getStarTotalData(recommendStarMap, totalCount, totalStar);
    totalStar = data.totalStar;
    totalCount = data.totalCount;
  }

  if (totalStar === 0 || totalCount === 0) {
    star = 0;
  } else {
    star = Number((totalStar / totalCount).toFixed(1));
  }
  return { star, hadReview };
};

export * from './utils/type';
